import { render } from "./EchartsRing.vue?vue&type=template&id=18d6b674"
import script from "./EchartsRing.vue?vue&type=script&lang=js"
export * from "./EchartsRing.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])